import { BasicColumnTypes } from '@opengov/ogql-types';
import { EConditionalComparisonOperators, EReportColumnTypes } from '@opengov/reporting-types';
import { IConditionalReportColumn } from '@opengov/reporting-types/src/reportColumns-immer';

export const getCalculationString = (column) => {
  return getCalcBreakdown(column).slice(1, -1);
};

export const getCalcBreakdown = (column) => {
  if (column.columnType !== EReportColumnTypes.infix) {
    return column.displayName;
  } else {
    return `(${getCalcBreakdown(column.leftColumn)} ${column.operator} ${getCalcBreakdown(column.rightColumn)})`;
  }
};

export const getCondBreakdown = (column: IConditionalReportColumn<any>, locale) => {
  if (column.columnType === EReportColumnTypes.conditional) {
    const firstColumnCondition = column.conditions[0];
    let ifCase = firstColumnCondition.returnedValue;
    let elseCase = column.else;
    if (column.type === BasicColumnTypes.Percent) {
      ifCase = locale.reportTable.percentFormat({ value: parseFloat(ifCase) });
      elseCase = locale.reportTable.percentFormat({ value: parseFloat(elseCase) });
    }
    if (firstColumnCondition.operator === EConditionalComparisonOperators.between) {
      const val1 = firstColumnCondition.lowerBound.value
        ? firstColumnCondition.lowerBound.value
        : firstColumnCondition.lowerBound.displayName;
      const val2 = firstColumnCondition.upperBound.value
        ? firstColumnCondition.upperBound.value
        : firstColumnCondition.upperBound.displayName;
      return locale.reportTable.columnEdit.conditionalBetween({
        column: column.sourceColumn.displayName,
        value1: val1,
        value2: val2,
        ifCase: ifCase,
        elseCase: elseCase
      });
    } else {
      return locale.reportTable.columnEdit.conditionalOneFactor({
        column: column.sourceColumn.displayName,
        condition: locale.reportTable.columnEdit.readableCondition[firstColumnCondition.operator],
        value: firstColumnCondition.matchValue.value
          ? firstColumnCondition.matchValue.value
          : firstColumnCondition.matchValue.displayName,
        ifCase: ifCase,
        elseCase: elseCase
      });
    }
  } else {
    return '';
  }
};
